import {ETextParamType_OnCatchError} from './const';
import {hel_setText} from './moduleCaller';

import type {JsonObject} from '../../../HeliportJS/dist/models/json';

/**
 * HeliScriptのコンポーネントで `OnCatchError` コールバックを呼び出す。
 * @see https://hikky.atlassian.net/wiki/spaces/VKETCLOUD/pages/800031291/HeliScript#OnCatchError
 * @param itemName - `null` を指定した場合は、すべてのコンポーネントで呼び出される。「,」を含めてはならない。
 * @param errorType - 「,」を含めてはならない。
 * @param errorDetail
 */
export const callbackHsOnCatchError = (
  itemName: string | null,
  errorType: string,
  errorDetail: JsonObject
): void => {
  hel_setText(
    ETextParamType_OnCatchError,
    `${itemName ?? ''},${errorType},${JSON.stringify(errorDetail)}`
  );
};
